<template>
  <b-card>
    <validation-observer ref="addGroupRules">
	
	  <b-form @submit.prevent>
	    <b-row>
	      <b-col md="12">
	        <b-form-group :label="$t('Group Name')" label-for="group-name">
	  		<validation-provider
	  		  #default="{ errors }"
	  		  :name="$t('Group Name')"
	  		  rules="required"
	  		>
	  		  <b-form-input 
			  :placeholder="$t('Please input')+$t('Group Name')" 
			  v-model="data.groupName"/>
	  		  <small class="text-danger">{{ errors[0] }}</small>
	  		</validation-provider>  
	        </b-form-group>
	      </b-col>
	      
	  	<b-col md="12">
	  	  <b-form-group :label="$t('Group Description')" label-for="group-description">
	  		<validation-provider
	  		  #default="{ errors }"
	  		  :name="$t('Group Description')"
	  		  rules="required"
	  		>
	  		  <b-form-input 
			  :placeholder="$t('Please input')+$t('Group Description')" 
			  v-model="data.groupDescription"/>
	  		  <small class="text-danger">{{ errors[0] }}</small>
	  		</validation-provider>   
	  	  </b-form-group>
	  	</b-col>
	  
	      <b-col md="12">
	        <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
	          {{$t("Submit")}}
	        </b-button>
	        <b-button type="reset" variant="outline-secondary">
	          {{$t("Reset")}}
	        </b-button>
	      </b-col>
	    </b-row>
	  </b-form>
	  	
		
    </validation-observer>	
	  
    
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,BFormSelect
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { addGroup, editGroup, getGroup } from '@/api/user'

export default {
  name: 'Detail',
  props: {
  	  isEdit:{
  		  type: Boolean,
  		  default: false
  	  }
  },	
  components: {
	ValidationProvider,
	ValidationObserver,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
	required
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data:{
        groupName: null,
        groupDescription: null
      },
    }
  },
  created() {
	localize(this.$i18n.locale)  
	if(this.isEdit){
	  this.getGroup(this.$route.params.name)
	}  
  },
  methods: {
	//用户组详情
	getGroup(name){
		getGroup(name)
		.then(response => {
		  this.data = response.data
		})
	},
	//提交表单
	onSubmit(){	
	  if(this.isEdit){
	    this.editGroup()
	  }	
	  else{
		this.addGroup()
	  }
	},
	//编辑用户组
	editGroup(){
		
	  this.$refs.addGroupRules.validate().then(success => {
	    if (success) {
	      editGroup(this.data)
	      .then(response => {
	        this.$router.replace({ name: 'users-group-list' })
	            .then(() => {
	              this.$toast({
	                component: ToastificationContent,
	                position: 'top-right',
	                props: {
	                  title: '修改成功',
	                  icon: 'CoffeeIcon',
	                  variant: 'success',
	                  text: '修改用户组成功 !',
	                },
	              })
	            })
	      })
	    }
	  })	
		
	  
	},
    //添加用户组
    addGroup(){
		
	  this.$refs.addGroupRules.validate().then(success => {
	    if (success) {
	      addGroup(this.data)
	      .then(response => {
	        this.$router.replace({ name: 'users-group-list' })
	            .then(() => {
	              this.$toast({
	                component: ToastificationContent,
	                position: 'top-right',
	                props: {
	                  title: '添加成功',
	                  icon: 'CoffeeIcon',
	                  variant: 'success',
	                  text: '添加用户组成功 !',
	                },
	              })
	            })
	      })
	    }
	  })	
		
    }


  },
}
</script>
